
import Accordion from '@/components/Shared/Accordion/index.vue'
import InnerPageTitle from '../Shared/InnerPageTitle/index.vue'
export default {
  components: {
    Accordion,
    InnerPageTitle,
  },
  data() {
    return {
      faq: this.$store.state.settings.contents.faq,
      search: '',
    }
  },
  computed: {
    filterFaq() {
      if (this.search === '') return this.$store.state.settings.contents.faq
      return (
        this.$store.state.settings.contents.faq?.filter(
          (item) =>
            item.title?.toLowerCase().includes(this.search.toLowerCase()) ||
            item.overview?.toLowerCase().includes(this.search.toLowerCase())
        ) || []
      )
    },
  },
}
